import { FormattedMessage } from 'react-intl';
import Link from 'components/Link';
import Typography from 'components/Typography';

const a1 = (chunks: string) => (
  <Link href="/terms" target="_blank" variant="secondary">
    {chunks}
  </Link>
);

const a2 = (chunks: string) => (
  <Link href="/privacy" target="_blank" variant="secondary">
    {chunks}
  </Link>
);

export default function TermsOfService() {
  return (
    <Typography component="div" variant="caption">
      <FormattedMessage
        defaultMessage="By continuing to use AllTrails, you agree to our <a1>Terms of Service</a1> and <a2>Privacy Policy</a2>."
        values={{
          a1,
          a2
        }}
      />
    </Typography>
  );
}
